import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ComponentsModule } from '@freelancer/components';
import { DirectivesModule } from '@freelancer/directives';
import { FeatureFlagsModule } from '@freelancer/feature-flags';
import { PipesModule } from '@freelancer/pipes';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { UserProfilePictureModule } from '../user-profile-picture/user-profile-picture.module';
import { UserProfileStatsHeaderComponent } from './user-profile-stats-header/user-profile-stats-header.component';
import { UserProfileStatsReputationItemComponent } from './user-profile-stats-reputation/user-profile-stats-reputation-item/user-profile-stats-reputation-item.component';
import { UserProfileStatsReputationComponent } from './user-profile-stats-reputation/user-profile-stats-reputation.component';
import { UserProfileStatsVerificationsItemComponent } from './user-profile-stats-verifications/user-profile-stats-verifications-item/user-profile-stats-verifications-item.component';
import { UserProfileStatsVerificationsComponent } from './user-profile-stats-verifications/user-profile-stats-verifications.component';
import { UserProfileStatsComponent } from './user-profile-stats.component';

@NgModule({
  declarations: [
    UserProfileStatsComponent,
    UserProfileStatsHeaderComponent,
    UserProfileStatsReputationItemComponent,
    UserProfileStatsReputationComponent,
    UserProfileStatsVerificationsComponent,
    UserProfileStatsVerificationsItemComponent,
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    FeatureFlagsModule,
    PipesModule,
    MatTooltipModule,
    UiModule,
    TrackingModule,
    UserProfilePictureModule,
    ComponentsModule,
  ],
  exports: [
    UserProfileStatsComponent,
    UserProfileStatsReputationComponent,
    UserProfileStatsVerificationsComponent,
  ],
})
export class UserProfileStatsModule {}
